// extracted by css-extract-rspack-plugin
export default {"IconButton":"add-column-header-module__IconButton__MaDB2","DisabledButton":"add-column-header-module__DisabledButton__TbpDr"};